import { render, staticRenderFns } from "./Almacenes.vue?vue&type=template&id=38d0d197&scoped=true"
import script from "./Almacenes.vue?vue&type=script&lang=ts"
export * from "./Almacenes.vue?vue&type=script&lang=ts"
import style0 from "./Almacenes.vue?vue&type=style&index=0&id=38d0d197&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d0d197",
  null
  
)

export default component.exports